<template>
  <v-card>
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title> Create an account </v-toolbar-title>
    </v-toolbar>
    <v-card-text class="text-center" style="padding: 20px 50px 20px 50px">
      <v-alert dense dismissible type="error" v-model="alert"
        >{{ errorMessage }}
      </v-alert>
      <v-form @submit.prevent="signup" ref="form" v-model="valid">
        <v-row>
          <v-col class="py-0" cols="12" sm="6">
            <v-text-field
              :rules="[rules.required]"
              dense
              label="Name"
              outlined
              ref="name"
              v-model.trim="name"
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="6">
            <v-select
              :items="colors"
              label="Favorite Color"
              :rules="[rules.required]"
              outlined
              dense
              v-model="favoriteColor"
            ></v-select>
          </v-col>
        </v-row>
        <v-row align="baseline" justify="center">
          <v-col class="py-0" cols="12">
            <v-text-field
              :rules="[rules.email, rules.required]"
              dense
              label="Email"
              outlined
              ref="email"
              v-model.trim="email"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0" cols="12" sm="6">
            <v-text-field
              :rules="[rules.password, rules.required]"
              :type="showPassword ? 'text' : 'password'"
              dense
              label="Password"
              outlined
              ref="password"
              v-model.trim="password"
            ></v-text-field>
          </v-col>
          <v-col class="pt-0 pb-0" cols="12" sm="6">
            <v-text-field
              :rules="[
                rules.confirmPassword(password, confirmPassword),
                rules.required,
              ]"
              :type="showPassword ? 'text' : 'password'"
              dense
              label="Confirm"
              outlined
              ref="confirmPassword"
              v-model.trim="confirmPassword"
            >
              <template v-slot:append>
                <v-checkbox
                  class="ma-0 pa-0"
                  off-icon="mdi-eye-off"
                  on-icon="mdi-eye"
                  v-model="showPassword"
                  style="width: 25px; height: 25px !important"
                ></v-checkbox>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="pr-3">
          <v-spacer />
          <v-btn
            class="primary text-capitalize body-2 font-weight-medium elevation-0 px-5"
            dark
            style="border-radius: 4px"
            :loading="loading"
            @click="loading = true"
            type="submit"
            >Signup
          </v-btn>
        </v-row>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-row align="center" justify="center">
        <v-col class="text-center ma-4" cols="12">
          <span class="font-weight-medium body-1 text--secondary"
            >Already have an account?
            <a @click="$router.push('login')">Login</a></span
          >
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import router from '@/router'
import colors from 'vuetify/lib/util/colors'

const firebase = require('../firebaseConfig')
export default {
  name: 'SignupForm',
  data: () => ({
    colors: Object.keys(colors),
    favoriteColor: null,
    valid: false,
    name: null,
    title: '',
    email: null,
    password: null,
    confirmPassword: null,
    errorMessage: '',
    showPassword: false,
    alert: false,
    loading: false,
    rules: {
      required: (value) => !!value || 'Required.',
      password: (value) => {
        const pattern = /.{6,}/gm
        return pattern.test(value) || 'Must be a least 6 characters'
      },
      confirmPassword: (ps1, ps2) => ps1 === ps2 || "Passwords don't match",

      email: (value) => {
        const pattern =
          /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g
        return pattern.test(value) || 'Must be a valid email'
      },
    },
  }),
  methods: {
    signup() {
      this.validate()
      if (this.valid) {
        firebase.auth
          .createUserWithEmailAndPassword(this.email, this.password)
          .then((user) => {
            this.$store.commit('SET_CURRENT_USER', user.user)
            this.$store.commit('SET_AUTHENTICATED', true)
            let usersRef = firebase.usersCollection.doc(
              firebase.auth.currentUser.uid
            )
            let userInfo = {
              title: this.title,
              name: this.name,
              favoriteColor:
                colors[this.favoriteColor]?.base || this.favoriteColor,
              profileImageUrl: null,
              darkMode: false,
              cubeCount: 0,
              soundsEnabled: false,
            }
            usersRef.get().then(() => {
              usersRef.set(userInfo)
              this.$store.dispatch('fetchUserProfile')
            })
            router.push('dashboard')
          })
          .catch((err) => {
            this.alert = true
            this.errorMessage = err.message
          })
      }
      this.loading = false
    },
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
  },
}
</script>
